export default {
  processor: (session, approve) => {
    // TODO: Stubbed out for now. Implement this at some point.
    approve();
  },
};
